import { getData } from "ajv/dist/compile/context";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";
import { helper } from "lib/helper";
import usersModel from "models/users.model";
import { useEffect, useState } from "react";
import {
  useParams,
  useHistory,
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

const tabs = [""];

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    dob: "",
    type: "",
  })


  const getUserDetails = async () => {
    try {
      const foundUser = await usersModel.getSpecificUser(id);
      // console.log(foundUser,"------------------")
      if (foundUser) {
        const formattedUser = {
          ...foundUser.data,
          dob: new Date(foundUser.data.dob).toISOString().split("T")[0],
        };
        setUserData(formattedUser);
        setUser(formattedUser);
      } else {
        setUser(null);
      }
      setIsLoading(false);
    } catch (error) {
      setUser(null);
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const updateUserDetails = async (e) => {
    e.preventDefault();
    if (id) {
      try {
         usersModel.editUserDetails(userData, id).then((result) => {
          if(result) {
          helper.sweetalert.toast("User updated", "success");
          navigate(-1); // Navigate after successful update
        }
      })} catch (error) {
        helper.sweetalert.toast(error.response?.data?.message || "Update failed", "warning");
      }
    } else {
      helper.sweetalert.toast("Please fill all fields", "warning");
    }
  };

  useEffect(() => {
    getUserDetails();
  }, [id]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Container className="pt-7" fluid>
      <Card className="shadow">
        <CardHeader>
          <h1>{user ? "Edit User" : "No user found"}</h1>
        </CardHeader>
        {user && (
          <CardBody>
            <Form onSubmit={updateUserDetails}>
              <Row>
                <Col md="4">
                <FormGroup>
                <Label for="name">First Name</Label>
                <Input
                  type="text"
                  name="firstName"
                  id="firstName"
                  defaultValue={user?.firstName}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
                </Col>
                <Col md="4">
                <FormGroup>
                <Label for="name">Last Name</Label>
                <Input
                  type="text"
                  name="lastName"
                  id="lastName"
                  defaultValue={user?.lastName}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
                </Col>
                <Col md="4">
                <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  defaultValue={user?.email}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
                </Col>
              </Row>
            
              <Row>
                <Col md='4'>
                <FormGroup>
                <Label for="mob">Mobile</Label>
                <Input
                  type="tel"
                  name="mobileNo"
                  id="mobileNo"
                  defaultValue={user?.mobileNo}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
                </Col>
                <Col md='4'>
                <FormGroup>
                <Label for="dob">Date of Birth</Label>
                <Input
                  type="date"
                  name="dob"
                  id="dob"
                  defaultValue={user?.dob}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
                </Col>
                <Col md='4'>
                <FormGroup>
                <Label for="type">Type</Label>
                <Input
                  type="select"
                  name="type"
                  id="type"
                  defaultValue={user?.type}
                  onChange={handleChange}
                  required
                >
                  <option value="user">User</option>
                  <option value="buddy">Buddy</option>
                </Input>
              </FormGroup>
                </Col>
              </Row>
             
              
              
             <div className="d-flex justify-content-between align-items-center">
              <BackButton />
              <AddButton title='Save Changes' />
             </div>
              {/* <Button color="primary">Save Changes</Button> */}
            </Form>
          </CardBody>
        )}
      </Card>
    </Container>
  );
};

export default EditUser;
